import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Object Locations',
  basePath: '/itemserver-object-locations',
  columns: [
    { key: 'location', label: 'Location', sortable: true },
  ],
  fields: [
    { key: 'location', label: 'Location', type: 'text', required: true },
  ],
});
